module.exports = __webpack_public_path__ + "static/media/bikeBackground.55025339.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Bike/bikeBackground.svg
// module id = 911
// module chunks = 0